export default {
  en: {
    title: 'Analytics',
    loadingProgress: 'Loading progress',
    progressTitle: 'Progress',
    progressSubtitle: 'Your journey in numbers',
    streakLabel: 'Streak',
    streakHint: 'Days in a row',
    trainingsLabel: 'Trainings',
    trainingsHint: 'Sessions completed',
    messagesLabel: 'Messages',
    messagesHint: 'Sent in chat',
    wordsSaidLabel: 'Words said',
    wordsSaidHint: 'Unique words',
    wordsLearnedLabel: 'Words learned',
    wordsLearnedHint: 'In active vocabulary',
    topicsLabel: 'Topics mastered',
    topicsHint: 'Out of {{total}} vocabulary topics',
  },
  ru: {
    title: 'Аналитика',
    loadingProgress: 'Загружаю прогресс',
    progressTitle: 'Прогресс',
    progressSubtitle: 'Твой путь в цифрах',
    streakLabel: 'Стрик',
    streakHint: 'Дней подряд',
    trainingsLabel: 'Тренировок',
    trainingsHint: 'Занятий завершено',
    messagesLabel: 'Сообщений',
    messagesHint: 'Отправлено в чате',
    wordsSaidLabel: 'Слов сказано',
    wordsSaidHint: 'Уникальных слов',
    wordsLearnedLabel: 'Слов выучено',
    wordsLearnedHint: 'В активном словаре',
    topicsLabel: 'Освоено тем',
    topicsHint: 'Из {{total}} словарных тем',
  },
  de: {
    title: 'Statistiken',
    loadingProgress: 'Fortschritt wird geladen',
    progressTitle: 'Fortschritt',
    progressSubtitle: 'Deine Reise in Zahlen',
    streakLabel: 'Streak',
    streakHint: 'Tage in Folge',
    trainingsLabel: 'Trainings',
    trainingsHint: 'Abgeschlossene Sitzungen',
    messagesLabel: 'Nachrichten',
    messagesHint: 'Im Chat gesendet',
    wordsSaidLabel: 'Gesagte Wörter',
    wordsSaidHint: 'Einzigartige Wörter',
    wordsLearnedLabel: 'Gelernte Wörter',
    wordsLearnedHint: 'Im aktiven Wortschatz',
    topicsLabel: 'Beherrschte Themen',
    topicsHint: 'Von {{total}} Wortschatz-Themen',
  },
  pt: {
    title: 'Estatísticas',
    loadingProgress: 'Carregando progresso',
    progressTitle: 'Progresso',
    progressSubtitle: 'Sua jornada em números',
    streakLabel: 'Sequência',
    streakHint: 'Dias seguidos',
    trainingsLabel: 'Treinos',
    trainingsHint: 'Sessões concluídas',
    messagesLabel: 'Mensagens',
    messagesHint: 'Enviadas no chat',
    wordsSaidLabel: 'Palavras ditas',
    wordsSaidHint: 'Palavras únicas',
    wordsLearnedLabel: 'Palavras aprendidas',
    wordsLearnedHint: 'No vocabulário ativo',
    topicsLabel: 'Tópicos dominados',
    topicsHint: 'De {{total}} tópicos de vocabulário',
  },
  fr: {
    title: 'Statistiques',
    loadingProgress: 'Chargement de la progression',
    progressTitle: 'Progression',
    progressSubtitle: 'Ton parcours en chiffres',
    streakLabel: 'Série',
    streakHint: 'Jours d’affilée',
    trainingsLabel: 'Entraînements',
    trainingsHint: 'Sessions terminées',
    messagesLabel: 'Messages',
    messagesHint: 'Envoyés dans le chat',
    wordsSaidLabel: 'Mots dits',
    wordsSaidHint: 'Mots uniques',
    wordsLearnedLabel: 'Mots appris',
    wordsLearnedHint: 'Dans le vocabulaire actif',
    topicsLabel: 'Sujets maîtrisés',
    topicsHint: 'Sur {{total}} sujets de vocabulaire',
  },
  es: {
    title: 'Estadísticas',
    loadingProgress: 'Cargando progreso',
    progressTitle: 'Progreso',
    progressSubtitle: 'Tu recorrido en números',
    streakLabel: 'Racha',
    streakHint: 'Días seguidos',
    trainingsLabel: 'Entrenamientos',
    trainingsHint: 'Sesiones completadas',
    messagesLabel: 'Mensajes',
    messagesHint: 'Enviados en el chat',
    wordsSaidLabel: 'Palabras dichas',
    wordsSaidHint: 'Palabras únicas',
    wordsLearnedLabel: 'Palabras aprendidas',
    wordsLearnedHint: 'En el vocabulario activo',
    topicsLabel: 'Temas dominados',
    topicsHint: 'De {{total}} temas de vocabulario',
  },
};
